import type { ReactElement } from "react";

import styles from "./SectionTitle.module.css";

type Props = Readonly<{
  children: string;
  testId?: string;
}>;

export default function SectionTitle({
  children,
  testId,
}: Props): ReactElement {
  return (
    <h1 data-testid={testId} className={styles.sectionTitle}>
      {children}
    </h1>
  );
}
